import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { Resources } from '../../resource';
import { stPoolContributions } from '../../../services/socialTradingService';

const RESOURCE = Resources.socialTradingPoolContributions;

export const poolContributionsDataProvider: CustomDataProvider = {
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== RESOURCE) {
      return Promise.reject(new Error('Unsupported getList resource'));
    }
    const { page = 1, perPage = 20 } = params.pagination || {};
    const filter = params.filter || {};
    const res = await stPoolContributions({
      poolId: (filter.poolId as string | undefined) || undefined,
      roomId: (filter.roomId as string | undefined) || undefined,
      userId: (filter.userId as string | undefined) || undefined,
      roomName: (filter.roomName as string | undefined) || undefined,
      limit: perPage,
      offset: (page - 1) * perPage,
    });
    const items = res?.items || [];
    return {
      data: items.map((row) => ({ ...row, id: row.id })),
      total: res?.total ?? items.length,
    };
  },
};
